module.exports = __webpack_public_path__ + "img/icon_cs_feature_elearning.0c43c1a8.png";